// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dissension":"dissension_JpMiq","item":"item_POmeh"};